import { z } from "zod";

export type CheckMessageIsGuestUnreadResponse = z.infer<typeof CheckMessageIsGuestUnreadResponseSchema>;
export const CheckMessageIsGuestUnreadResponseSchema = z.object({
  is_guest_unread: z.boolean(),
});
